import { render } from "./WeatherAlerts.vue?vue&type=template&id=4848eadc&scoped=true"
import script from "./WeatherAlerts.vue?vue&type=script&lang=js"
export * from "./WeatherAlerts.vue?vue&type=script&lang=js"

import "./WeatherAlerts.vue?vue&type=style&index=0&id=4848eadc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4848eadc"]])

export default __exports__